import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../../components/Box';
import Heading from '../../../components/Heading';
import Button from '../../../components/Button';
import Container from '../../../components/UI/Container';
import { BannerWrapper } from './banner.style';
import { enFr } from '../../../utils';
import { openCalendarModal } from '../../../utils/modal-helpers.jsx';

const BannerSection = ({
  row,
  contentWrapper,
  topTitle,
  title,
  subTitle,
  buttonWrapper,
  fillButton,
}) => {
  return (
    <BannerWrapper id="welcome">
      <Container>
        <Box {...row}>
          <Box {...contentWrapper}>
            <Heading
              {...topTitle}
              className="title top-title"
              content={enFr(
                'Welcome to Awaken',
                'Bienvenue chez Awaken'
              )}
            />
            <Heading
              {...title}
              className="title"
              content={enFr(
                'Web & App Development | AI Consulting',
                'Développement web et applicatif | Consultation en IA'
              )}
            />
            <Heading
              {...subTitle}
              content={enFr(
                'We build custom web and mobile applications, integrate AI into real workflows, and help organizations operate smarter. Over 20 years of production-grade technical execution.',
                'Nous développons des applications web et mobiles sur mesure, intégrons l\u2019IA dans vos processus concrets et aidons les organisations à fonctionner plus intelligemment. Plus de 20 ans d\u2019exécution technique de calibre production.'
              )}
            />
            <Box {...buttonWrapper} style={{ marginTop: '30px' }}>
              <Button
                {...fillButton}
                title={enFr('BOOK A STRATEGY CALL', 'RÉSERVER UN APPEL STRATÉGIQUE')}
                onClick={openCalendarModal}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  row: PropTypes.object,
  contentWrapper: PropTypes.object,
  topTitle: PropTypes.object,
  title: PropTypes.object,
  subTitle: PropTypes.object,
  buttonWrapper: PropTypes.object,
  fillButton: PropTypes.object,
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentWrapper: {
    width: ['100%', '100%', '100%', '100%', '100%'],
    mb: '40px',
  },
  topTitle: {
    fontSize: ['46px', '52px', '58px', '64px', '72px'],
    fontWeight: '300',
    color: '#fff',
    letterSpacing: '-0.025em',
    mt: ['0', '0', '0', '20px', '20px'],
    mb: ['10px', '10px', '10px', '12px', '12px'],
    lineHeight: '1.1',
    textAlign: 'center',
  },
  title: {
    fontSize: ['32px', '36px', '40px', '46px', '52px'],
    fontWeight: '300',
    color: '#fff',
    letterSpacing: '-0.025em',
    mt: ['0', '0', '0', '0', '0'],
    mb: ['15px', '15px', '15px', '20px', '20px'],
    lineHeight: '1.15',
    textAlign: 'center',
  },
  subTitle: {
    fontSize: ['17px', '18px', '20px', '22px', '22px'],
    fontWeight: '300',
    color: 'rgba(255, 255, 255, 0.8)',
    letterSpacing: '-0.01em',
    mt: ['0', '0', '0', '10px', '10px'],
    mb: ['10px', '10px', '10px', '10px', '10px'],
    lineHeight: '1.6',
    textAlign: 'center',
    maxWidth: '700px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '700',
    p: ['0px 20px', '10px 28px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '200px'],
    height: ['44px', '50px'],
    minHeight: 'auto',
  },
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'center',
    mt: '35px',
  },
};

export default BannerSection;
